import Vue from 'vue';
import ElementUI from 'element-ui';
Vue.use(ElementUI, { size: 'small' });

function getTempOption(options) {
  // add showClose、offset
  // header的高度是60，所以此处是60
  return typeof options === 'string'
    ? { message: options, showClose: true, offset: 70 }
    : { ...options, showClose: true, offset: 70 };
}
Vue.prototype.$messageSelf = options => {
  window._vm.$message(getTempOption(options));
};

Vue.prototype.$messageSelf.success = options => {
  window._vm.$message.success(getTempOption(options));
};
Vue.prototype.$messageSelf.warning = options => {
  window._vm.$message.warning(getTempOption(options));
};
Vue.prototype.$messageSelf.info = options => {
  window._vm.$message.info(getTempOption(options));
};
Vue.prototype.$messageSelf.error = options => {
  window._vm.$message.error(getTempOption(options));
};
